import type { AgentConfig } from "@/types/agent/agent";
import { LANGUAGES } from "@/utils/config/elevenlabs";

/**
 * The language a genie must always answer in, or null when it may follow the
 * caller's language. Only an explicitly emptied `language_presets` (what
 * handle-agent stores when multi-language is switched off) pins the language;
 * a genie with no `language_presets` key at all keeps today's behaviour.
 */
export const getPinnedResponseLanguage = (settings?: AgentConfig | null): string | null => {
  const presets = (settings?.conversation_config as { language_presets?: unknown } | undefined)?.language_presets;
  if (presets === undefined || presets === null) return null;
  const count = Array.isArray(presets) ? presets.length : Object.keys(presets as object).length;
  if (count > 0) return null;

  const code = settings?.conversation_config?.agent?.language || "en";
  return LANGUAGES.find((l) => l.code === code)?.name ?? code;
};
